export default __webpack_public_path__ + "static/media/driver-download.d333debc.webp";